<template>
  <div class="kwk-referals" v-if="isDataLoaded">

    <div class="referals-error" v-if="errorMsg">
      <h4><slot name="lblHeadlineNoFriends"></slot></h4>
      <div class="error-box" v-html="errorMsg"></div>
    </div>

    <div class="referals-none" v-else-if="usedReferrals === 0">
      <h4><slot name="lblHeadlineNoFriends"></slot></h4>
      <div class="referals-subtitle"><slot name="txtSublineNoFriends"></slot></div>
      <div class="referals-simon-image"><slot name="imgNoFriends"></slot></div>
      <div v-if="hasHistoryReferals" class="referals-history">
        <button @click="onClickHistoryButton()">
          <dyn-slot :slot-data="slotData">
            <slot name="dynReferalHistory"></slot>
          </dyn-slot>
        </button>
      </div>
    </div>

    <div class="referals-exists" v-else>
      <h4>
        <img class="referals-state-badge" :src="getSlotText(`urlImage${usedReferrals}Friends`)" alt="" />
        <span><slot :name="`txtHeadline${usedReferrals}Friends`"></slot></span>
      </h4>
      <div class="referals-subtitle"><slot :name="`txtSubline${usedReferrals}Friends`"></slot></div>
      <div class="referals-list">
        <div class="referal-item" v-for="(referal,index) in referalList" :key="index">
          <div class="face"  :class="{active: isActive(referal), leaves: maxReferalsReached}"><img :src="getReferalImageSrc(referal,index)"></div>
          <div v-if="isPending(referal)" class="description active">
            <div class="description-block">
              <div class="bonus-value">{{getReferalBonusValue(referal, index, currentYear)}}</div>
              <div class="bonus-runtime pending"><slot name="lblBonusPending"></slot><a class="info-link-icon" @click="onClickModalIcon()"></a></div>
            </div>
            <div class="bonus-friend bonus-friend-pending" v-if="referal.friendFirstName"><slot name="lblBonusFrom"></slot> {{referal.friendFirstName}}</div>
          </div>
          <div v-else-if="isActive(referal)" class="description active">
            <div class="description-block">
            <div class="bonus-value">{{getReferalBonusValue(referal, index, currentYear)}}</div>
              <div class="bonus-runtime" v-if="getReferalStartdate(referal) && getReferalEnddate(referal)">{{getReferalStartdatFormated(referal)}} &#8212; {{getReferalEnddateFormated(referal)}}</div>
            </div>
             <div class="bonus-friend" v-if="referal.friendFirstName"><slot name="lblBonusFrom"></slot> {{referal.friendFirstName}}</div>
          </div>
          <div v-else class="description">
            <div class="bonus-value"><slot :name="`lblBonusPreviewFriend${index}`"></slot></div>
          </div>
        </div>
        <SimonModal
          :is-visible="showInfoModal"
          @hide="showInfoModal = false"
          id="referal-info-modal"
        >
          <slot name="txtBonusPendingInfoModal"></slot>
        </SimonModal>
      </div>
      <div v-if="hasHistoryReferals" class="referals-history">
        <button @click="onClickHistoryButton()" class="filled yellow">
          <dyn-slot :slot-data="slotData">
            <slot name="dynReferalHistory"></slot>
          </dyn-slot>
        </button>
      </div>
    </div>
    <SimonModal v-if="hasHistoryReferals"
      :is-visible="showHistoryModal"
      @hide="showHistoryModal = false"
      size="large"
      custom-modal-class="referal-history-modal"
    >
      <template v-slot:modalTitle>
        <h4>
          <dyn-slot :slot-data="slotData">
            <slot name="dynReferalHistory"></slot>
          </dyn-slot>
        </h4>
      </template>
      <div class="kwk-referals">
        <div class="referals-list">
          <div class="referal-item" v-for="(referal,index) in referalHistoryList" :key="index">
            <div class="face"  :class="{active: isActive(referal)}"><img :src="getReferalImageSrc(referal,index)"></div>
            <div v-if="isPending(referal)" class="description active">
            <div class="description-block">
              <div class="bonus-value">{{getReferalBonusValue(referal, index, lastYear)}}</div>
              <div class="bonus-runtime pending"><slot name="lblBonusPending"></slot></div>
            </div>
            <div class="bonus-friend bonus-friend-pending" v-if="referal.friendFirstName"><slot name="lblBonusFrom"></slot> {{referal.friendFirstName}}</div>
          </div>
          <div v-else-if="isActive(referal)" class="description active">
            <div class="description-block">
            <div class="bonus-value">{{getReferalBonusValue(referal, index, lastYear)}}</div>
              <div class="bonus-runtime" v-if="getReferalStartdate(referal) && getReferalEnddate(referal)">{{getReferalStartdatFormated(referal)}} &#8212; {{getReferalEnddateFormated(referal)}}</div>
            </div>
            <div class="bonus-friend" v-if="referal.friendFirstName"><slot name="lblBonusFrom"></slot> {{referal.friendFirstName}}</div>
          </div>
          </div>
        </div>
      </div>
    </SimonModal>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import dateFormatter from '@/mixins/formatters/dateFormatter'
import syncProperty from '@/mixins/syncProperty'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'KwkDashboardReferals',
  components: { SimonModal },
  mixins: [
    syncProperty('referalsLoaded', 'isDataLoaded'),
    dateFormatter
  ],
  created () {
    this.STATE_EMPTY = ''
    this.STATE_PENDING = 'PENDING'
    this.STATE_IN_ACTIVATION = 'IN_ACTIVATION'
    this.STATE_ACTIVE = 'ACTIVE'
    this.STATE_CANCELED = 'CANCELLED'
  },
  data () {
    return {
      friendReferralStatus: null,
      errorMsg: '',
      showInfoModal: false,
      showHistoryModal: false
    }
  },
  computed: {
    slotData: function () {
      return {
        usedReferrals: this.usedReferrals,
        usedReferralsWithUnit: this.usedReferralsWithUnit,
        currentYear: this.currentYear,
        lastYear: this.lastYear
      }
    },
    fullReferalList: function () {
      return this.friendReferralStatus?.currentReferralBookings || []
    },
    referalList: function () {
      const referalList = this.getReferalListByYear(this.currentYear)
      while (referalList.length < this.totalAvailableReferrals) {
        referalList.push({ status: this.STATE_EMPTY })
      }
      return referalList
    },
    referalHistoryList: function () {
      return this.getReferalListByYear(this.lastYear)
    },
    totalAvailableReferrals: function () {
      return this.friendReferralStatus?.totalAvailableReferrals || 0
    },
    usedReferrals: function () {
      return this.friendReferralStatus?.usedReferrals || 0
    },
    usedReferralsWithUnit: function () {
      return this.usedReferrals + ' Freund' + (this.usedReferrals !== 1 ? 'e' : '')
    },
    maxReferalsReached: function () {
      return this.usedReferrals === this.totalAvailableReferrals
    },
    hasHistoryReferals: function () {
      return this.referalHistoryList.length > 0
    },
    currentYear: function () {
      return new Date().getFullYear()
    },
    lastYear: function () {
      return this.currentYear - 1
    }
  },
  methods: {
    isActive: function (referal) {
      return referal.status && (referal.status === this.STATE_ACTIVE)
    },
    isPending: function (referal) {
      return referal.status && (referal.status === this.STATE_PENDING || referal.status === this.STATE_IN_ACTIVATION)
    },
    isCanceled: function (referal) {
      return referal.status && referal.status === this.STATE_CANCELED
    },
    getReferalListByYear: function (year) {
      const this_ = this
      const filteredList = this.fullReferalList.filter(
        (referal) => {
          const filterDate = this_.getBookingdate(referal)
          return !this_.isCanceled(referal) && filterDate.getFullYear() === year
        })
      return filteredList
    },
    getReferalImageSrc: function (referal, index) {
      const type = this.isActive(referal) ? 'Active' : 'Inactive'
      return this.getSlotText(`urlImage${type}${index}Friends`)
    },
    getPromotion: function (referal) {
      let promotion = null
      if (referal && referal.promotions && referal.promotions.length > 0) {
        promotion = referal.promotions[0]
      }
      return promotion
    },
    getIncentive: function (promotion) {
      let incentive = null
      if (promotion && promotion.incentives && promotion.incentives.length > 0) {
        incentive = promotion.incentives[0]
      }
      return incentive
    },
    getReferalBonusValue: function (referal, index, year) {
      let bonus = ''
      const promotion = this.getPromotion(referal)
      const incentive = this.getIncentive(promotion)
      if (incentive) {
        if (incentive.type === 'volume') {
          bonus = incentive.amount + incentive.unit
        } else if (incentive.type === 'credit') {
          // todo: we have no case for credit right know, so this implementation is not final and not testet
          bonus = incentive.discount
        }
      }
      bonus += ' ' + this.getSlotText('lblBonusActive')
      if (index < 2) {
        return bonus
      }
      let specialBoni = []
      try {
        specialBoni = JSON.parse(this.getSlotText('jsonSpecialBoni'))
      } catch (e) {
      }
      const bookingTs = this.getBookingdate(referal).getTime() / 1000
      specialBoni.forEach(bonusItem => {
        if (bonusItem.start < bookingTs && bookingTs < bonusItem.end) {
          bonus += ' ' + bonusItem.bonus
        }
      })
      return bonus
    },
    getReferalStartdate: function (referal) {
      let date = null
      const promotion = this.getPromotion(referal)
      if (promotion && promotion.effectiveDate) {
        date = new Date(Date.parse(promotion.effectiveDate))
      }
      return date
    },
    getReferalStartdatFormated: function (referal) {
      return this.dateToMonthYearFormatter(this.getReferalStartdate(referal))
    },
    getReferalEnddate: function (referal) {
      let date = null
      const promotion = this.getPromotion(referal)
      if (promotion && promotion.expirationDate) {
        date = new Date(Date.parse(promotion.expirationDate))
      }
      return date
    },
    getReferalEnddateFormated: function (referal) {
      return this.dateToMonthYearFormatter(this.getReferalEnddate(referal))
    },
    getBookingdate: function (referal) {
      let date = null
      if (referal && referal.bookingDate) {
        date = new Date(Date.parse(referal.bookingDate))
      }
      return date
    },
    triggerTracking: function () {
      const data = {
        page_levels: [
          'mein-simon',
          'uebersicht',
          'freunde-werben'
        ],
        login_status: 'not logged in', // check/set in tracking
        page_type: 'self service',
        platform_type: 'browser view',
        information_action: 'reveal',
        information_name: this.usedReferrals + ' of ' + this.totalAvailableReferrals + ' referrals',
        information_ui_type: 'panel',
        information_trigger: 'system'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('pageview', data)
      }
    },
    onClickHistoryButton () {
      this.showHistoryModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'historic referrals',
        information_ui_type: 'overlay',
        information_trigger: 'button'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    onClickModalIcon () {
      this.showInfoModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'referral pending',
        information_ui_type: 'overlay',
        information_trigger: 'link'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    }
  },
  apollo: {
    friendReferralStatus: function () {
      return wrapQuery(
        gql`query friendReferral{
          friendReferralStatus {
            currentReferralBookings {
              campaignId
              bookingDate
              activeFrom
              expirationDate
              status
              friendFirstName
              promotions {
                bookingState
                context
                description
                duration {
                  amount
                  unit
                  formattedUnit
                }
                effectiveDate
                expirationDate
                incentiveInfoDescription
                incentiveInfoHeading
                name
                promotionId
                promotionType
                incentives {
                  ... on CreditIncentive {
                    id
                    title
                    description
                    type
                    discount
                    targetId
                    targetEntity
                    targetFee
                  }
                  ... on VolumeIncentive {
                    id
                    title
                    description
                    type
                    amount
                    unit
                  }
                }
              }
            }
            friendReferralEligibility {
              isEligibleForReferral
              ineligibilityReason
            }
            totalAvailableReferrals
            usedReferrals
          }
        }`,
        this, 'friendReferralStatus', {},
        () => {
          this.isDataLoaded = true
          this.$emit('loaded')
          this.triggerTracking()
        },
        (error) => {
          splitError(error).forEach(e => {
            this.errorMsg = e.message
          })
          if (this.errorMsg) {
            const data = {
              type: 'technical',
              message: this.errorMsg
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
          this.isDataLoaded = true
          this.$emit('loaded')
        }
      )
    }
  }
}
</script>
